import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Services', href: '/services' },
  { name: 'About', href: '/about' },
  { name: 'Case Studies', href: '/case-studies' },
  { name: 'Careers', href: '/careers' },
];

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed transition-all duration-300 ${
        isScrolled 
          ? 'sm:left-1/2 sm:-translate-x-1/2 sm:bg-white sm:shadow-lg sm:py-2 sm:px-4 sm:rounded-full sm:w-auto sm:mt-4 w-full bg-white shadow-lg py-2'
          : 'w-full bg-transparent py-4'
      }`}
    >
      <div className={`${isScrolled ? 'w-full sm:w-fit' : 'max-w-7xl'} mx-auto ${!isScrolled && 'px-4 sm:px-6 lg:px-8'}`}>
        <div className={`flex justify-between items-center transition-all duration-300 ${
          isScrolled ? 'h-10 space-x-4' : 'h-16'
        }`}>
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png" 
                alt="SellAbroad.io" 
                className={`transition-all duration-300 ${
                  isScrolled ? 'h-8' : 'h-8 sm:h-12'
                }`}
                style={{ minWidth: '120px', objectFit: 'contain' }}
              />
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden sm:flex sm:items-center sm:space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === item.href
                    ? 'text-[#0049ac] border-[#0049ac]'
                    : 'text-gray-500 border-transparent hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className={`inline-flex items-center border border-transparent text-base font-medium rounded-full text-white bg-[#0049ac] hover:bg-[#0049ac]/90 whitespace-nowrap ${
                isScrolled ? 'px-4 py-2 text-sm' : 'px-6 py-3'
              }`}
            >
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center sm:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="sr-only">Open main menu</span>
              {mobileMenuOpen ? (
                <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div 
          className={`sm:hidden transition-all duration-300 ${
            mobileMenuOpen 
              ? 'opacity-100 max-h-64' 
              : 'opacity-0 max-h-0 pointer-events-none'
          }`}
        >
          <div className="py-2 space-y-1 bg-white rounded-lg shadow-lg mt-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block px-4 py-2 text-base font-medium transition-colors duration-200 ${
                  location.pathname === item.href
                    ? 'text-[#0049ac] bg-blue-50'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="px-4 py-2">
              <Link
                to="/contact"
                className="block w-full px-4 py-2 text-base font-medium text-center text-white bg-[#0049ac] hover:bg-[#0049ac]/90 rounded-full"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;